import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { deletePayType } from "../thunks/deletePayType";
import { setFetchState } from "../payTypesDataReducer";

export const usePayTypeDelete = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.listing.payTypes.fetchState
  );

  const dispatch = useDispatch();
  const dispatchDeletePayType = React.useCallback(
    (id: string) => dispatch(deletePayType(id)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchDeletePayType] as [
    typeof fetchState,
    typeof dispatchDeletePayType
  ];
};
